var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-btn',{staticClass:"ma-3",attrs:{"color":"primary","to":_vm.zoznamUrl}},[_vm._v("Zoznam klientov")])],1)],1),_c('socialny-podnik-profile',{attrs:{"item":_vm.item,"editable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }